module.exports = process.env.NODE_ENV !== "production" ? require("./env.dev") : require("./env.prod")
